module.exports = __webpack_public_path__ + "static/media/digi2.5aab2639.jpg";